<template>
  <div class="content">
      <div class="common-space-between common-items-center">
        <div class="common-items-center">
          <SelectBlock title="充电商状态" placeholder="选择状态" keyVal="enabled" ref="enabled"         :size="this.$store.state.inputSize"  width="110" @getVal="getValParms"/>
          <InputBlock title="搜索条件" :width="240">
                <el-input v-model="name" :size="this.$store.state.inputSize" placeholder="企业名称/联系人/企业账号/手机号" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
          </InputBlock>
		  <Month title="选择时间" ref="mouth" :width="150" @getDate="getDate"></Month>
          <el-button type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"  @click="searchBtn">搜索</el-button>
          <el-button type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
        </div> 
        <el-button type="primary" icon="el-icon-plus" :size="this.$store.state.btnSize"  @click="addBtn">新增</el-button>
      </div>
       <div class="warp-table">
        <el-table  :data="tableData" :empty-text="this.$store.state.tableEmpty" :size="this.$store.state.tableSize" ref="giftTable" style="width: 100%"  :height="this.$store.state.windowHeight-260">
            <el-table-column align="center" header-align="center" prop="date"       label="序号"        width="80">
                <template slot-scope="scope">{{scope.$index+1}}</template>
            </el-table-column>
            <el-table-column align="left"   header-align="left"  :show-overflow-tooltip="true" prop="systemName" label="系统名称"    width="200"/>
            <el-table-column align="left"   header-align="left"  :show-overflow-tooltip="true" prop="companyName" label="企业名称"    width="200"/>
            <el-table-column align="left"   header-align="left"   prop="areaAddress"     label="省/市/区县"  width="240"></el-table-column>
            <el-table-column align="left"   header-align="left"   prop="account"     label="企业账号"      width="200">
              <template slot-scope="scope">
                <div class="common-space-between common-items-center" @mouseenter="enter(scope.$index)" @mouseleave="leave(scope.$index)">
                    {{scope.row.account}}
                    <CopyBtn :text="scope.row.account"  v-show="mouseIndex == scope.$index"/>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="left"   header-align="left"   prop="userName"    label="联系人"  width="100"></el-table-column>
            <el-table-column align="left"   header-align="left"   prop="phone"       label="手机号"  width="120"></el-table-column>
            <el-table-column align="left"   header-align="left"   prop="operator"    label="最近操作人"  width="120"></el-table-column>
            <el-table-column align="left"   header-align="left"   prop="createTime"  label="创建时间"    width="180"></el-table-column>
            <el-table-column align="left"   header-align="left"   prop="updateTime"  label="更新时间"    width="180"></el-table-column>
            <el-table-column align="center" header-align="center" prop="enabled"     label="状态"       width="180">
              <template slot-scope="scope">
                <div class="common-space-around">
                       <span v-if="scope.row.enabled*1 == 1" class="open">正常</span>
                       <span v-else-if="scope.row.enabled*1 == 0" class="disable">禁用</span>
                       <span v-else>-</span>
                </div>
              </template>  
            </el-table-column>
            <el-table-column align="center" header-align="center" fixed="right"     label="操作"       width="160">
              <template slot-scope="scope" >
                <div class="common-items-center common-space-around operate">
                  <el-link :underline="false" @click="ediBtn(scope.row)" type="primary" size="mini">编辑</el-link>
                  <el-popconfirm title="确定重置密码么？" @confirm="resetPaw(scope.row)">
                      <el-link :underline="false" slot="reference"  type="warning" size="mini">重置密码</el-link>
                  </el-popconfirm>
                  <!-- <el-popconfirm title="确定删除么？" @confirm="deleteBtn(scope.row)">
                      <el-button slot="reference"  type="danger" size="mini">删除</el-button>
                  </el-popconfirm> -->
                  <el-link  :underline="false" :type='scope.row.enabled*1 == 1 ? "info":"success"' size="mini">
                      <span v-if="scope.row.enabled*1 == 1" @click="isOpenBtn(scope.row,0)">禁用</span>
                      <span v-if="scope.row.enabled*1 == 0" @click="isOpenBtn(scope.row,1)">启用</span>  
                  </el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size"/>
       </div>
       <AddBlock ref="add"></AddBlock>
       <EditorBlock ref="edi"></EditorBlock>
  </div>
</template>

<script>
import AddBlock from './block-list/add-block.vue'
import EditorBlock from './block-list/editor-block.vue'
import {userApi} from '@/utils/config'
import {postFun,putFun,deleteFun} from '@/utils/httpFun'
import {scroll} from '@/components/component-mixin/block-scroll'
import Month from '@/components/component-block/block-month.vue'
export default {
  name: 'index',
  mixins: [scroll],
  components:{
     AddBlock:AddBlock,
     EditorBlock:EditorBlock,
	 Month: Month
  },
  data:()=>({
    defaultProps: {
        children: 'childMBs',
        label: 'name'
    },
    input:"",
    value1:true,
    FoctoryList:[],
    selectList:[],
    tableData: [{}],
    
    enabled:"",
    factoryType:"",
    name:"",
    current:1,
    size:10,
    total:10,
    mouseIndex:-1,
	dataParam:{
		startTime:'',
		endTime:''
	}
  }),

  created(){
      this.getList()
  },
  methods:{
	  //获取时间
	  getDate(ev) {
		  console.log(ev)
	      this.dataParam.startTime =ev.startDate==''? '': ev.startDate+" 00:00:00"
	      this.dataParam.endTime =ev.endDate==''?'' : ev.endDate+" 23:59:59"
	  },
    // 鼠标移入事件
    enter(index){
      // console.log("移入");
      this.mouseIndex = index;
    },
    // 鼠标离开事件
    leave(){
      // console.log("离开");
      this.mouseIndex = -1;
    },
    //获取所有工厂数据的列表
    async getList(){
        let parms={
            param:{
              isDel:0,   //未删除
              enabled:this.enabled,  
              companyName:this.name,
			  startTime:this.dataParam.startTime,
			  endTime:this.dataParam.endTime
            },
            current:this.current,
            size:this.size
        }
        await postFun(userApi.GETCHARGERSPAGE,parms,res=>{
              this.tableData = res.data.records
              this.total = res.data.total
              this.size = res.data.size
              this.current = res.data.current
        })
    },

    //获取搜索框及其下拉的框的值
    getValParms(ev){
        
        if(ev.key=="enabled"){
           this.enabled = ev.indexNo
        }
        if(ev.key=="factoryType"){
          this.factoryType = ev.indexNo
        }
      },



      //搜索
      searchBtn(){
        this.getList()
      },

      resetBtn(){
		this.$refs.mouth.clear()
		this.dataParam.startTime=""
		this.dataParam.endTime=""
        this.name = ""
        this.enabled = ""
        this.factoryType = ""
        this.current = 1
        // this.$refs.enabled.setVal("")
        this.getList()
      },

    //新增弹窗
    addBtn(){
      this.$refs.add.showMessage(this.FoctoryList);
    },

    //编辑弹窗
    ediBtn(ev){
      let parms = {
          list:this.FoctoryList,
          val:ev
      }
      this.$refs.edi.showMessage(parms);
    },
    //重置密码
    resetPaw(ev){
      let parms = {
          id:ev.id,
          // operator:this.$store.state.operator 
      }
      postFun(userApi.RESETPASSWORD,parms,res=>{
          
          if(res.code==1 && res.data){
            this.$message({
              message: '密码重置成功',
              type: 'success'
            });
          }else{
            this.$message({
              message: '重置密码失败',
              type: 'warning'
            }); 
          }
      })
    },
    
    //启用禁用
    async isOpenBtn(ev,enabledMark){
      let parms = {
          id:ev.id,
          enabled:enabledMark,
          // operator:this.$store.state.operator
       }
       await postFun(userApi.ISENABLE,parms,res=>{
          if(res.code==1){
             this.getList()
          }
       })
    },

    //获取输入的值
    getVal(ev){
       
    },

    //删除
    async deleteBtn(ev){
       let parms = {
          factorId:ev.id,
          operator:this.$store.state.operator
       }
       await deleteFun(userApi.FACTORYDELETE,parms,res=>{
          if(res.code==1){
             this.getList()
          }
       })
    },

    //分页
    getPage(ev){
        this.size = ev.pageSize
        this.current = ev.pageNo 
        this.getList()
    },
  }
}
</script>
<style lang="scss" scoped>
     .content{
       box-sizing: border-box;
       padding:15px;
    }
    .warp-table{
      margin-top: 15px;
    }
    .operate{
      ::v-deep .el-button--mini{
        padding: 5px 8px;
      }
    }
</style>
